import { electronBridge } from '../../electron-bridge/electron-bridge';
import { useAppName } from '../../app-name/app-name';

export function useApplicationType() {
    const appName = useAppName();

    // app
    const isFirstResponder = appName === 'first-responder';
    const isCad = appName === 'cad';

    // platform
    const isElectronRewrite = electronBridge && 'isElectronRewrite' in electronBridge;
    const isElectron = !!electronBridge;
    const isLegacyElectron = isElectron && !isElectronRewrite;
    const isWeb = !isElectron;

    // app + platform
    const isCadElectron = isCad && isElectron;
    const isCadElectronRewrite = isCad && isElectronRewrite;
    const isCadLegacyElectron = isCad && isLegacyElectron;
    const isCadWeb = isCad && isWeb;
    const isFirstResponderElectron = isFirstResponder && isElectron;
    const isFirstResponderWeb = isFirstResponder && isWeb;

    return {
        isCad,
        isCadElectron,
        isCadElectronRewrite,
        isCadLegacyElectron,
        isCadWeb,
        isElectron,
        isElectronRewrite,
        isFirstResponder,
        isFirstResponderElectron,
        isFirstResponderWeb,
        isWeb,
    };
}
